import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AuthService, CalendarService, TranslatorService } from '../../../services';

@Component({
    selector: 'sn-usc-daily-sales-panel-advanced',
    templateUrl: './usc-daily-sales-panel-advanced.component.html',
    styleUrls: ['./usc-daily-sales-panel-advanced.component.css']
})
export class UscDailySalesPanelAdvancedComponent implements OnInit {
    @Input() sales_mode: string;
    @Input() scope_type: string;
    @Input() scope_value: string;
    @Input() scope_user: any;       //NOTE: scope_user changes depending on current month or previous month.  current month it is of type cosultant_achievement whereas previous month it is of type action_plan
    @Input() scope_month: string;
    @Input() control_id: number;
    @Output() public viewChange = new EventEmitter();

    public p2w_goal_exceeded:number = 0;
    public p2w_quota_exceeded:number = 0;
    public isLeader: boolean;
    public isSalesVsQuota: boolean = false;
    public isSalesVsGoal: boolean = false;
    public is_current_month: boolean = true;
    public isConsultant: boolean = false;
    public sales_metrics: any[];
    public is_sales_metrics_loaded = false;
    public daily_goal: any;
    public is_daily_goal_loaded: boolean = false;
    public is_daily_goal_unavailable: boolean = false;

    constructor(
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public authService: AuthService,
    ) { }

    ngOnInit() {
        this.isLeader = this.uscStoreService.isLeader();
        if (this.scope_month == undefined) this.scope_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.isConsultant = this.scope_type == "associate";
        this.isSalesVsQuota = this.isLeader && this.sales_mode == 'quota';
        this.isSalesVsGoal = this.isLeader && this.sales_mode == 'goal';
        var dataset_type = this.isSalesVsQuota ? "todays_sales_vs_quota" : "todays_sales_vs_goal";
        if (this.isLeader) {
            this.uscStoreService.getP2WSalesMetrics(dataset_type, this.scope_type, this.scope_value).subscribe(result => {
                this.sales_metrics = result;
                this.is_sales_metrics_loaded = true;
            });
        } else {
            this.uscStoreService.getP2WSalesMetrics(dataset_type).subscribe(result => {
                this.sales_metrics = result;
                this.is_sales_metrics_loaded = true;
            });
        }

        if (this.isConsultant) {
            this.uscStoreService.getDailyGoals(this.scope_user.ur_user_ID).subscribe(result => {
                this.daily_goal = result.items.find(p => p.cs_subject == this.uscStoreService.getTodaysGoalSubject());
                if (this.daily_goal) {
                    this.is_daily_goal_loaded = true;
                    this.analyzeSalesMetrics();
                } else {
                    this.is_daily_goal_loaded = true;
                    this.is_daily_goal_unavailable = true;
                }
            })
        }
    }

    analyzeSalesMetrics() {
        if (this.sales_metrics) {
            this.sales_metrics.forEach(m => {
                if (this.isSalesVsGoal && m.goal_pct >= 1) this.p2w_goal_exceeded++;
                if (this.isSalesVsQuota && m.quota_pct >= 1) this.p2w_quota_exceeded++;
            })
        }
    }

    gotoDetailedResults() {
        if (this.scope_type == undefined) {
            this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_associate_detailed_results);
        } else {
            var dr_view = this.isSalesVsGoal ? this.uscStoreService.view_p2w_goal_gross_adds_detail_results : this.uscStoreService.view_p2w_quota_gross_adds_detail_results;
            this.uscStoreService.setCurrentDetailResultScope({ scope_type: this.scope_type, scope_value: this.scope_value })
            this.uscStoreService.setCurrentView(dr_view);
        }
    }

    showAssociateDetailedResults(): boolean {
        return !this.uscStoreService.isLeader();
    }

    getTitle(): string {
        if (this.isConsultant) {
            return "Today - " + (this.is_current_month ? this.scope_user.AssociateName : this.scope_user.ur_associate_name);
        } else {
            if (this.uscStoreService.isLeader()) {
                if (this.scope_type == "agency") return "Today - Agency " + this.scope_value;
                return (this.scope_type == "channel") ? "Today - National" : "Today - Team " +  this.scope_value;
            } else {
                return "How today is shaping up?";
            }
        }
    }

    getDesc(): string {
        var desc = "";
        if (this.isConsultant) {
            if (this.daily_goal) desc = "Here are _NAME_ sales results for today:".replace('_NAME_', (this.is_current_month ? this.scope_user.AssociateName : this.scope_user.ur_associate_name));
        }
        else {
            if (this.isLeader) {
                var ahead = "Congratulations, you have achieved __AHEAD__ of your Plan2Win Daily Goal(s). ".replace('__AHEAD__', this.p2w_goal_exceeded.toString());
                desc = "Here are your sales results for today:";
                desc = (this.p2w_goal_exceeded > 0) ? ahead + desc : desc;
            } else {
                var ahead = "Congratulations, you have achieved __AHEAD__ of your Plan2Win Daily Goal(s). ".replace('__AHEAD__', this.p2w_goal_exceeded.toString());
                desc = "Here are your sales results for today:";
                desc = (this.p2w_goal_exceeded > 0) ? ahead + desc : desc;
            }
        }
        return desc;
    }

    getUnavailableDesc(): string {
        var desc = "";
        var name = this.scope_user != null ? this.scope_user.ur_associate_name : "";
        //if (this.is_action_plan_unavailable) desc = "Unable to retrieve current user's sales figures.".replace('_NAME_', name);
        return desc;
    }

    getDashboardClass() {
        return this.uscStoreService.getCurrentView() == this.uscStoreService.view_p2w_plan_2_win ? "sm-goal dsp" : "sm-quota dsp";
    }

    viewTopResults() {
        var content = { view: "top_results", control_id: this.control_id };
        this.viewChange.emit(content);  
    }

    viewTopDailyResults() {
        var content = { view: "top_daily_results", control_id: this.control_id };
        this.viewChange.emit(content);  
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-daily-sales-panel-advanced/usc-daily-sales-panel-advanced.component.ts